import { logEvent, type AnalyticsCallOptions } from "firebase/analytics"
import { analytics } from "@/firebase"

export const useLogEvent = (eventName: string, eventParams?: { [p: string]: any }, options?: AnalyticsCallOptions) => {
  return logEvent(analytics, eventName, eventParams, options)
}
